import { render, staticRenderFns } from "./WkButton.vue?vue&type=template&id=cbd6c14a&scoped=true&"
import script from "./WkButton.vue?vue&type=script&lang=js&"
export * from "./WkButton.vue?vue&type=script&lang=js&"
import style0 from "./WkButton.vue?vue&type=style&index=0&id=cbd6c14a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd6c14a",
  null
  
)

export default component.exports